import Main from "./components/Main";
import PdfSources from "./components/PdfSources";
import {
    Routes,
    Route,
    BrowserRouter
} from 'react-router';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Main/>}/>
                <Route path="/pdf/instructions" element={<PdfSources document="instructions"/>}/>
                <Route path="/pdf/techInfo" element={<PdfSources document="techInfo"/>}/>
                <Route path="/pdf/cardMembrane" element={<PdfSources document="cardMembrane"/>}/>
                <Route path="/pdf/cardCornerFlashing" element={<PdfSources document="cardCornerFlashing"/>}/>
                <Route path="/pdf/cardFlashing" element={<PdfSources document="cardFlashing"/>}/>
                <Route path="/pdf/cardSeam" element={<PdfSources document="cardSeam"/>}/>
                <Route path="*" element={<Main/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
